var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25205 0.75C3.25205 0.335786 3.58784 0 4.00205 0H15.25C15.6642 0 16 0.335786 16 0.75C16 1.16421 15.6642 1.5 15.25 1.5H4.00205C3.58784 1.5 3.25205 1.16421 3.25205 0.75Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25205 5.94137C3.25205 5.52716 3.58784 5.19137 4.00205 5.19137H15.25C15.6642 5.19137 16 5.52716 16 5.94137C16 6.35558 15.6642 6.69137 15.25 6.69137H4.00205C3.58784 6.69137 3.25205 6.35558 3.25205 5.94137Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25205 11.1327C3.25205 10.7185 3.58784 10.3827 4.00205 10.3827H15.25C15.6642 10.3827 16 10.7185 16 11.1327C16 11.5469 15.6642 11.8827 15.25 11.8827H4.00205C3.58784 11.8827 3.25205 11.5469 3.25205 11.1327Z",
    fill: "#484848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H0.758056C1.17227 0 1.50806 0.335786 1.50806 0.75C1.50806 1.16421 1.17227 1.5 0.758056 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75Z",
    fill: "#484848"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.94137C0 5.52716 0.335786 5.19137 0.75 5.19137H0.758056C1.17227 5.19137 1.50806 5.52716 1.50806 5.94137C1.50806 6.35558 1.17227 6.69137 0.758056 6.69137H0.75C0.335786 6.69137 0 6.35558 0 5.94137Z",
    fill: "#484848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.1327C0 10.7185 0.335786 10.3827 0.75 10.3827H0.758056C1.17227 10.3827 1.50806 10.7185 1.50806 11.1327C1.50806 11.5469 1.17227 11.8827 0.758056 11.8827H0.75C0.335786 11.8827 0 11.5469 0 11.1327Z",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/iconList.4013a850.svg";
export { ForwardRef as ReactComponent };